import { queryOptions, useQuery } from '@tanstack/react-query'
import { getCategories } from '../services/getCategories.service'

export const categoriesQueryOptions = () =>
  queryOptions({
    queryKey: ['categories'],
    queryFn: getCategories,
  })

export function useCategories() {
  return useQuery(categoriesQueryOptions())
}
